// @need-translate
import {SchemeLink} from '../../../applink/SchemeLink';
import {getFormattedNumberWithSuffix} from '../../../common/shared/utils/getFormattedNumberWithSuffix';
import {twMerge} from '../../../common/twMerge';
import {LOG_SERIES_CLICK} from '../../../logging/logEvent';
import {Button} from '../../atoms/Button/Button';
import {ButtonColorScheme, ButtonSize} from '../../atoms/Button/Button.enum';
import {Image} from '../../atoms/Image/Image';
import {SeparatorType} from '../../atoms/Separator/SeparatorType.enum';
import {Text} from '../../atoms/Text/Text';
import {TextsWithSeparator} from '../../molecules/TextsWithSeparator/TextsWithSeparator';
import {ThumbnailRatio} from '../../molecules/ThumbnailWithBadges/ThumbnailRatio.constant';
import {ThumbnailType} from '../../molecules/ThumbnailWithBadges/ThumbnailType.enum';
import {WelcomeRecommendContentItemProps} from './WelcomeRecommendContentItemProps.interface';

export function WelcomeRecommendContentItem({
  scheme,
  src,
  alt,
  title,
  category,
  subCategory,
  viewCount,
  description,
  themeKeywordList,
  freeSlideCount = 0,
  className,
  ...props
}: WelcomeRecommendContentItemProps) {
  return (
    <div
      className={twMerge('rounded-12pxr bg-theme-bg-surface', className)}
      {...props}
    >
      <div className="px-24pxr pt-32pxr pb-24pxr">
        <div className="flex flex-col items-center">
          <Image
            src={src}
            ratio={ThumbnailRatio[ThumbnailType.Poster]}
            alt={alt || '썸네일'}
            className="h-195pxr w-136pxr overflow-hidden rounded-3pxr border-[0.5px] border-solid border-[rgb(var(--colors-static-mono-black)_/_7%)]"
          />
        </div>

        <div className="mt-16pxr flex h-160pxr w-full flex-col items-center">
          <div className="w-full text-center">
            <Text className="font-large3-bold text-theme-solid-100 line-clamp-1">
              {title}
            </Text>
          </div>
          <div className="mt-4pxr">
            <TextsWithSeparator
              texts={[
                category,
                subCategory,
                getFormattedNumberWithSuffix(viewCount),
              ]}
              separatorType={SeparatorType.Dot}
              className="font-small2 text-theme-solid-40"
            />
          </div>
          <div className="mt-8pxr h-36pxr w-full text-center">
            <Text className="font-small1 whitespace-pre-wrap text-theme-solid-60 line-clamp-2">
              {description}
            </Text>
          </div>
          <div className="mt-16pxr">
            {
              // 해상도가 320미만일 때는 키워드를 1개만 보여줘야함.
              window.innerWidth < 320
                ? themeKeywordList.length > 0 && (
                    <div className="mx-3pxr inline-flex items-center rounded-[100px] bg-theme-solid-20 py-3pxr px-8pxr">
                      <Text className="font-small2 text-theme-solid-100">
                        {`#${themeKeywordList[0]}`}
                      </Text>
                    </div>
                  )
                : themeKeywordList.map(themeKeyword => {
                    return (
                      <div
                        key={themeKeyword}
                        className="mx-3pxr inline-flex items-center rounded-[100px] bg-theme-solid-20 py-3pxr px-8pxr"
                      >
                        <Text className="font-small2 text-theme-solid-100">
                          {`#${themeKeyword}`}
                        </Text>
                      </div>
                    );
                  })
            }
          </div>
        </div>
        <div className="w-full">
          <SchemeLink scheme={scheme || undefined}>
            <Button
              size={ButtonSize.Large}
              colorScheme={ButtonColorScheme['2nd']}
              onClickCapture={LOG_SERIES_CLICK}
            >
              {`${freeSlideCount}화 무료 보러가기`}
            </Button>
          </SchemeLink>
        </div>
      </div>
    </div>
  );
}
